<template>
  <span v-html="renderAge()" />
</template>

<script>
const ageType = ['all', '7', '12', '15', '18', '19', '20']

export default {
  name: 'AgeGrade',
  props: {
    targetAge: {
      type: String,
      default: ''
    },
    section: {
      type: String,
      default: ''
    },
    size: {
      type: Number,
      default: 24
    }
  },
  methods: {
    renderAge () {
      const isMovieAll = (this.section === 'movie' && this.targetAge === '0')
      const age = isMovieAll ? 'all' : this.targetAge
      const isImageRender = (isMovieAll || Number(age) > 0) && ageType.includes(age)

      if (age === '20') return '청불'

      if (isImageRender) {
        const imageAltText = isMovieAll ? '전체 관람가' : `${Number(age) >= 18 ? '청소년 관람불가' : age + '세 이상 관람가'}`
        const imageSource = require(`@/assets/images/common/element-icons-72-x-72-ic-${this.section}-${age}-years.svg`)

        return `<img src="${imageSource}" width="${this.size}" height="${this.size}" :alt="${imageAltText} 아이콘">`
      } else {
        return '모든연령'
      }
    }
  }
}
</script>
